import * as _ from 'lodash';
import * as React from 'react';
import { default as Select, IValueLabelPair } from '../../../../modules/Form/Select';
import CheckBox from './CheckBox';

interface ISelectCheckProps {
  label: string;
  onChange?: (e: Array<IValueLabelPair>) => void;
  onChangeSubOption?: (e: IValueLabelPair) => void;
  fieldName?: string;
  errorMessage?: string;
  value?: any;
  options: Array<IValueLabelPair>;
  selectedValues: Array<IValueLabelPair>;
  subOptions?: Array<IValueLabelPair>;
  selectedSubOption?: IValueLabelPair;
  grid?: string;
}

interface ISelectCheckState {
  isOpened: boolean;
}

class SelectCheck extends React.Component<ISelectCheckProps, ISelectCheckState> {
  public state: ISelectCheckState;
  private node: any;

  constructor(props: ISelectCheckProps) {
    super(props);

    this.state = {
      isOpened: false
    };

    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  public toggleSelect(isOpened?: boolean) {
    if (!isOpened) {
      isOpened = !this.state.isOpened;
    }

    this.setState({ isOpened });
  }

  public handleOutsideClick(e: any) {
    if (this.state.isOpened) {
      if (this.node) {
        if (!this.node.contains(e.target)) {
          document.removeEventListener('click', this.handleOutsideClick);
          this.toggleSelect(false);
        }
      }
    }
  }

  private onChange(event: any, value?: IValueLabelPair) {
    if (value == undefined) {
      return;
    }

    let results;
    // tslint:disable-next-line:prefer-conditional-expression
    if (event.target.checked) {
      results = _.uniqBy(this.props.selectedValues, 'label').concat([value]);
    } else {
      results = _.uniqBy(this.props.selectedValues, 'label').filter(o => o.label != value.label);
    }

    if (this.props.onChange) {
      this.props.onChange(results);
    }

    this.setState({ isOpened: false });
  }

  public render() {
    const { fieldName, onChange, label, errorMessage, value, options, grid } = this.props;

    // Click outside
    document.addEventListener('click', this.handleOutsideClick);

    return (
      <div
        ref={node => {
          this.node = node;
        }}
        key={fieldName}
        className={
          'SelectCheck' + (this.state.isOpened ? ' active' : '') + (grid === 'single' ? ' SelectCheck--single' : '')
        }
      >
        <div
          className="Select-control"
          onClick={() => {
            this.toggleSelect();
          }}
        >
          <span className="Select-multi-value-wrapper" id="react-select-2--value">
            <div className="Select-placeholder">{label}</div>
          </span>
          <span className="Select-arrow-zone">
            <span className="Select-arrow" />
          </span>
        </div>
        {this.state.isOpened && (
          <div className={'SelectCheck__content'}>
            <div className="SelectCheck__select">
              {Array.isArray(this.props.subOptions) &&
                this.props.subOptions.length > 0 && (
                  <Select
                    onChange={this.props.onChangeSubOption}
                    name="sub"
                    clearFilterDisabled={true}
                    options={this.props.subOptions}
                    value={
                      this.props.selectedSubOption ? this.props.selectedSubOption.value : undefined
                    }
                  />
                )}
            </div>
            <div className="SelectCheck__checkboxes">
              {options.map((option, i) => (
                <CheckBox
                  key={option.label}
                  checked={this.props.selectedValues.some(v => v.label == option.label)}
                  {...{
                    ...option,
                    ['fieldName']: fieldName,
                    ['onChange']: event => this.onChange(event, option)
                  }}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default SelectCheck;



// WEBPACK FOOTER //
// ./src/components/FormGenerator/Form/components/SelectCheck.tsx